"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClosestMotorwayJunction$ = exports.ClosestMotorwayJunction$outboundSchema = exports.ClosestMotorwayJunction$inboundSchema = void 0;
exports.closestMotorwayJunctionToJSON = closestMotorwayJunctionToJSON;
exports.closestMotorwayJunctionFromJSON = closestMotorwayJunctionFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
/** @internal */
exports.ClosestMotorwayJunction$inboundSchema = z.object({
    description: z.string(),
    distance_in_metres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
    });
});
/** @internal */
exports.ClosestMotorwayJunction$outboundSchema = z.object({
    description: z.string(),
    distanceInMetres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ClosestMotorwayJunction$;
(function (ClosestMotorwayJunction$) {
    /** @deprecated use `ClosestMotorwayJunction$inboundSchema` instead. */
    ClosestMotorwayJunction$.inboundSchema = exports.ClosestMotorwayJunction$inboundSchema;
    /** @deprecated use `ClosestMotorwayJunction$outboundSchema` instead. */
    ClosestMotorwayJunction$.outboundSchema = exports.ClosestMotorwayJunction$outboundSchema;
})(ClosestMotorwayJunction$ || (exports.ClosestMotorwayJunction$ = ClosestMotorwayJunction$ = {}));
function closestMotorwayJunctionToJSON(closestMotorwayJunction) {
    return JSON.stringify(exports.ClosestMotorwayJunction$outboundSchema.parse(closestMotorwayJunction));
}
function closestMotorwayJunctionFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ClosestMotorwayJunction$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ClosestMotorwayJunction' from JSON`);
}
//# sourceMappingURL=closestmotorwayjunction.js.map